/** Default distance from the viewport bottom for bottom-anchored floating cards. */
export const FLOATING_SURFACE_BOTTOM_PX = 24;

const FLOATING_CLEARANCE_GAP_PX = 16;
const FLOATING_CLEARANCE_ATTRIBUTE = "data-floating-clearance";

export const FLOATING_CLEARANCE_SELECTOR = `[${FLOATING_CLEARANCE_ATTRIBUTE}]`;

/** Spread onto a sticky bottom bar so floating cards sit above it. */
export const FLOATING_CLEARANCE_PROPS = { [FLOATING_CLEARANCE_ATTRIBUTE]: "" } as const;

export function measureFloatingClearance(
  element: Element | null,
  viewportHeight: number
): number {
  if (!element) return FLOATING_SURFACE_BOTTOM_PX;
  const { top, height } = element.getBoundingClientRect();
  if (height === 0 || top >= viewportHeight) return FLOATING_SURFACE_BOTTOM_PX;
  return Math.max(FLOATING_SURFACE_BOTTOM_PX, viewportHeight - top + FLOATING_CLEARANCE_GAP_PX);
}
